import { Component, OnInit } from '@angular/core';
import { PharmaciesService } from '../services/pharmacies/pharmacies.service';

import { Doctor } from '../classes/doctor'
import { Auth } from '../services/auth.service';


@Component({
    selector: 'pharmacies',
    templateUrl: './pharmacies.component.html',
})
export class PharmaciesComponent implements OnInit {

    hasSysOpsPermission:boolean = false;

    constructor(protected pharmaciesService: PharmaciesService,
        protected auth: Auth) { }

    ngOnInit() {
        this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    }

    onFileChange(evt: any) {
        var inputValue = evt.target;
        let file = inputValue.files[0];
        var formData = new FormData();
        formData.append("pharmacies", file);
        this.pharmaciesService.updatePDF(formData).then((response) => {
            alert('Upload complete')
        }).catch((err)=>{
            alert('Error: '+err)
          })
    }

}



// WEBPACK FOOTER //
// ./src/app/pharmacies/pharmacies.component.ts